module.exports = __webpack_public_path__ + "img/steve-beveridge.ecc92a77.jpg";